import { formatPainter as formatPainter_1 } from './formatPainter.locstring.json';
import loc from 'owa-localize';
import RibbonButton, { RibbonButtonState } from './RibbonButton';
import updateCachedFormatViewState from '../../actions/updateCachedFormatViewState';

import { getFormatState } from 'roosterjs-editor-api';

const formatPainter: RibbonButton = {
    key: 'formatPainter',
    title: () => loc(formatPainter_1),
    imageSrc: require('../svg/formatpainter.svg'),
    buttonState: formatState =>
        formatState.formatPainterFormat ? RibbonButtonState.Checked : RibbonButtonState.Normal,
    onExecute: plugin => {
        let format = plugin.getFormatState();
        updateCachedFormatViewState(
            format,
            format.formatPainterFormat ? null : getFormatState(plugin.getEditor())
        );
    },
};

export default formatPainter;
